import { Directive, Input, TemplateRef, ViewContainerRef, OnInit, ElementRef } from '@angular/core';
import Chart from 'chart.js/auto';

@Directive({
	selector: '[appChart]'
})
export class ChartDirective implements OnInit {
	private hasView = false;
	private data : any;
	private config : any;
	private chart : any;

	@Input() set chartData(data : any) {
		this.data = data;		
	}	

	@Input() set chartConfig(config : any) {
		this.config = config;		
	}
	
	constructor(private ctx: ElementRef ) {

	}

	ngOnInit(): void {
		this.createChart();
	}


	private createChart = () => {
		//this.viewContainer.clear();
		//const ref = this.viewContainer.createEmbeddedView(this.templateRef);
		this.chart = (new Chart(this.ctx?.nativeElement, {
			type: 'bar', //this denotes tha type of chart
	  
			data: {// values on X-Axis
			  labels: ['2022-05-10', '2022-05-11', '2022-05-12','2022-05-13',
									   '2022-05-14', '2022-05-15', '2022-05-16','2022-05-17', ], 
				 datasets: [
				{
				  label: "Sales",
				  data: ['467','576', '572', '79', '92',
									   '574', '573', '576'],
				  backgroundColor: 'blue'
				},
				{
				  label: "Profit",
				  data: ['542', '542', '536', '327', '17',
										   '0.00', '538', '541'],
				  backgroundColor: 'limegreen'
				}  
			  ]
			},
			options: {
			  // aspectRatio:2.5,
			  // responsive: true
			}
			
		  }));
		  
	}
}
